import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}
export function Input({
  label,
  error,
  className = '',
  id,
  ...props
}: InputProps) {
  const inputId = id || props.name;
  return <div className="w-full space-y-2" data-id="element-116">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-white/90" data-id="element-117">
          {label}
        </label>}
      <input id={inputId} className={`
          flex h-12 w-full rounded-md border border-white/20 bg-white/5 px-3 py-2 text-sm text-white ring-offset-[#042854] file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-white/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#a1da52] focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50
          ${error ? 'border-red-500 focus-visible:ring-red-500' : ''}
          ${className}
        `} {...props} data-id="element-118" />
      {error && <p className="text-xs text-red-400" data-id="element-119">{error}</p>}
    </div>;
}